// ─────────────────────────────────────────────────────────────────────────────
// The i18n barrel — import from '../i18n', never from a file inside it.
//
//   import { useTranslation } from '../../i18n';
//
// Keeping the surface here means the internals (loader strategy, translator
// implementation, which Intl objects get memoised) can change without a sweep
// through the app.
//
// Full guide: docs/I18N.md
// ─────────────────────────────────────────────────────────────────────────────

export { default as I18nProvider, I18nContext } from './I18nProvider';
export { default as useTranslation } from './useTranslation';

export {
  LOCALES, LOCALE_IDS, NAMESPACES,
  DEFAULT_LOCALE, FALLBACK_LOCALE,
  isSupportedLocale, normalizeLocale, localeDescriptor,
  offeredLocaleIds, offeredLocales, isOfferedLocale, productDefaultLocale, fallbackLocale,
  fallbackLocalesFor,
  resolveInitialLocale,
  readStoredLocale, storeLocale, applyDocumentLocale,
  STORAGE_KEY,
} from './config';

export { LTR_TEXT, MIRROR_ICON, createFormatters, toAsciiDigits } from './format';
export { createTranslator } from './translator';
export { loadCatalog, loadNamespace, preloadCatalog, peekCatalog } from './loader';
